import React, { useState } from 'react';
import { Search, Plus, Edit2, Trash2, MoreVertical, Filter, Download, X as CloseIcon, Tag, FileText } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useScreenInit } from '../../useScreenInit.js';
export function VendorView() {
  const screenInit = useScreenInit();
  const [showAddModal, setShowAddModal] = useState(screenInit?.showAddModal || false);
  const [newVendor, setNewVendor] = useState({
    name: '',
    category: 'Food',
    subCategory: '',
    remark: ''
  });
  const [vendors, setVendors] = useState([{
    id: 1,
    name: 'Sysco Foods',
    category: 'Food',
    subCategory: 'Dairy, Dry Goods',
    status: 'Active'
  }, {
    id: 2,
    name: 'Restaurant Depot',
    category: 'Food',
    subCategory: 'Meat, Produce',
    status: 'Active'
  }, {
    id: 3,
    name: 'Profish',
    category: 'Food',
    subCategory: 'Seafood',
    status: 'Active'
  }, {
    id: 4,
    name: 'Coastal Sunbelt',
    category: 'Food',
    subCategory: 'Produce',
    status: 'Active'
  }, {
    id: 5,
    name: 'PepsiCo',
    category: 'Beverages',
    subCategory: 'Soda',
    status: 'Active'
  }, {
    id: 6,
    name: 'Wash Gas',
    category: 'Utilities',
    subCategory: 'Gas',
    status: 'Active'
  }]);
  const handleAddVendor = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newVendor.name) return;
    const vendorToAdd = {
      id: vendors.length + 1,
      ...newVendor,
      status: 'Active'
    };
    setVendors([vendorToAdd, ...vendors]);
    setNewVendor({
      name: '',
      category: 'Food',
      subCategory: '',
      remark: ''
    });
    setShowAddModal(false);
  };
  return <div className="space-y-6" data-id="element-729">
      {/* Add Vendor Modal */}
      <AnimatePresence data-id="element-730">
        {showAddModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-731">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowAddModal(false)} className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" data-id="element-732" />
            <motion.div initial={{
          scale: 0.95,
          opacity: 0,
          y: 20
        }} animate={{
          scale: 1,
          opacity: 1,
          y: 0
        }} exit={{
          scale: 0.95,
          opacity: 0,
          y: 20
        }} className="relative w-full max-w-lg bg-white rounded-[32px] shadow-2xl overflow-hidden" data-id="element-733">
              <div className="p-8" data-id="element-734">
                <div className="flex justify-between items-start mb-6" data-id="element-735">
                  <div className="w-12 h-12 bg-emerald-100 rounded-2xl flex items-center justify-center text-emerald-600" data-id="element-736">
                    <Plus size={24} data-id="element-737" />
                  </div>
                  <button onClick={() => setShowAddModal(false)} className="p-2 hover:bg-slate-100 rounded-full transition-colors text-slate-400" data-id="element-738">
                    <CloseIcon size={20} data-id="element-739" />
                  </button>
                </div>

                <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-740">
                  Add New Vendor
                </h3>
                <p className="text-sm text-slate-500 mb-8" data-id="element-741">
                  Enter vendor details to add them to your master list.
                </p>

                <form onSubmit={handleAddVendor} className="space-y-5" data-id="element-742">
                  <div data-id="element-743">
                    <label className="block text-xs font-bold text-slate-700 mb-2 uppercase tracking-wider" data-id="element-744">
                      Vendor Name
                    </label>
                    <div className="relative" data-id="element-745">
                      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-746">
                        <Tag size={18} className="text-slate-400" data-id="element-747" />
                      </div>
                      <input type="text" required value={newVendor.name} onChange={e => setNewVendor({
                    ...newVendor,
                    name: e.target.value
                  })} placeholder="e.g. Sysco Foods" className="w-full pl-11 pr-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:bg-white focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 outline-none transition-all" data-id="element-748" />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4" data-id="element-749">
                    <div data-id="element-750">
                      <label className="block text-xs font-bold text-slate-700 mb-2 uppercase tracking-wider" data-id="element-751">
                        Category
                      </label>
                      <select value={newVendor.category} onChange={e => setNewVendor({
                    ...newVendor,
                    category: e.target.value
                  })} className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:bg-white focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 outline-none transition-all appearance-none" data-id="element-752">
                        <option data-id="element-753">Food</option>
                        <option data-id="element-754">Beverages</option>
                        <option data-id="element-755">Utilities</option>
                        <option data-id="element-756">Supplies</option>
                        <option data-id="element-757">Services</option>
                      </select>
                    </div>
                    <div data-id="element-758">
                      <label className="block text-xs font-bold text-slate-700 mb-2 uppercase tracking-wider" data-id="element-759">
                        Sub-Category
                      </label>
                      <input type="text" value={newVendor.subCategory} onChange={e => setNewVendor({
                    ...newVendor,
                    subCategory: e.target.value
                  })} placeholder="e.g. Dairy, Meat" className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:bg-white focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 outline-none transition-all" data-id="element-760" />
                    </div>
                  </div>

                  <div data-id="element-761">
                    <label className="block text-xs font-bold text-slate-700 mb-2 uppercase tracking-wider" data-id="element-762">
                      Remark
                    </label>
                    <div className="relative" data-id="element-763">
                      <div className="absolute top-3 left-4 pointer-events-none" data-id="element-764">
                        <FileText size={18} className="text-slate-400" data-id="element-765" />
                      </div>
                      <textarea value={newVendor.remark} onChange={e => setNewVendor({
                    ...newVendor,
                    remark: e.target.value
                  })} rows={3} placeholder="Add any special notes or remarks..." className="w-full pl-11 pr-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:bg-white focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 outline-none transition-all resize-none" data-id="element-766" />
                    </div>
                  </div>

                  <div className="flex gap-3 pt-4" data-id="element-767">
                    <button type="button" onClick={() => setShowAddModal(false)} className="flex-1 py-3 px-4 bg-slate-100 hover:bg-slate-200 text-slate-600 rounded-xl text-sm font-bold transition-all" data-id="element-768">
                      Cancel
                    </button>
                    <button type="submit" className="flex-1 py-3 px-4 bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl text-sm font-bold shadow-lg shadow-emerald-500/20 transition-all" data-id="element-769">
                      Add Vendor
                    </button>
                  </div>
                </form>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      <div className="flex items-center justify-between" data-id="element-770">
        <div data-id="element-771">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-772">
            Vendor Management
          </h2>
          <p className="text-sm text-slate-500" data-id="element-773">
            Master data for purchasing and COGS tracking
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-774">
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-xl text-xs font-bold text-slate-600 hover:bg-slate-50 transition-all shadow-sm" data-id="element-775">
            <Download size={14} data-id="element-776" />
            Export List
          </button>
          <button onClick={() => setShowAddModal(true)} className="flex items-center gap-2 px-6 py-2 bg-slate-900 text-white rounded-xl text-sm font-bold shadow-lg shadow-slate-900/20 hover:bg-slate-800 transition-all" data-id="element-777">
            <Plus size={16} data-id="element-778" />
            Add New Vendor
          </button>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-id="element-779">
        <div className="p-4 border-b border-slate-50 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-780">
          <div className="relative flex-1 max-w-md" data-id="element-781">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-782" />
            <input type="text" placeholder="Search vendors by name or category..." className="w-full pl-10 pr-4 py-2 bg-slate-50 border border-slate-100 rounded-xl text-sm focus:bg-white focus:ring-2 focus:ring-slate-900/5 focus:border-slate-900 outline-none transition-all" data-id="element-783" />
          </div>
          <div className="flex items-center gap-2" data-id="element-784">
            <button className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-lg transition-all" data-id="element-785">
              <Filter size={18} data-id="element-786" />
            </button>
            <div className="h-4 w-[1px] bg-slate-200 mx-1" data-id="element-787" />
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-788">
              Showing {vendors.length} Vendors
            </p>
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-789">
          <table className="w-full text-left" data-id="element-790">
            <thead data-id="element-791">
              <tr className="bg-slate-50/50" data-id="element-792">
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-793">
                  Vendor Name
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-794">
                  Category
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-795">
                  Sub-Category
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-796">
                  Status
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-right" data-id="element-797">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50" data-id="element-798">
              {vendors.map(vendor => <tr key={vendor.id} className="hover:bg-slate-50 transition-colors group" data-id="element-799">
                  <td className="px-6 py-4" data-id="element-800">
                    <div className="flex items-center gap-3" data-id="element-801">
                      <div className="w-8 h-8 bg-slate-100 rounded-lg flex items-center justify-center text-xs font-bold text-slate-600" data-id="element-802">
                        {vendor.name.charAt(0)}
                      </div>
                      <span className="text-sm font-bold text-slate-900" data-id="element-803">
                        {vendor.name}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-804">
                    <span className="px-2 py-1 bg-slate-100 text-slate-600 text-[10px] font-bold rounded-md uppercase" data-id="element-805">
                      {vendor.category}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-xs font-medium text-slate-500" data-id="element-806">
                    {vendor.subCategory}
                  </td>
                  <td className="px-6 py-4" data-id="element-807">
                    <span className="flex items-center gap-1.5 text-[10px] font-bold text-emerald-600" data-id="element-808">
                      <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full" data-id="element-809" />
                      {vendor.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-810">
                    <div className="flex items-center justify-end gap-1" data-id="element-811">
                      <button className="p-2 text-slate-300 hover:text-slate-600 transition-colors" data-id="element-812">
                        <Edit2 size={14} data-id="element-813" />
                      </button>
                      <button className="p-2 text-slate-300 hover:text-rose-500 transition-colors" data-id="element-814">
                        <Trash2 size={14} data-id="element-815" />
                      </button>
                      <button className="p-2 text-slate-300 hover:text-slate-600 transition-colors" data-id="element-816">
                        <MoreVertical size={14} data-id="element-817" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}